const CHUNK_LOAD_ERROR =
  /Loading chunk [\d]+ failed|ChunkLoadError|Failed to fetch dynamically imported module/;

function reloadForUpdate() {
  const url = new URL(window.location.href);
  if (url.searchParams.has('_refresh')) return;
  url.searchParams.set('_refresh', String(Date.now()));
  window.location.replace(url.toString());
}

export function registerChunkLoadRecovery() {
  window.addEventListener('error', (event) => {
    if (CHUNK_LOAD_ERROR.test(event.message)) {
      reloadForUpdate();
    }
  });

  window.addEventListener('unhandledrejection', (event) => {
    const message = event.reason?.message || String(event.reason ?? '');
    if (CHUNK_LOAD_ERROR.test(message)) {
      reloadForUpdate();
    }
  });
}

export function startVersionCheck() {
  const currentBuildId = process.env.REACT_APP_BUILD_ID;
  if (process.env.NODE_ENV !== 'production' || !currentBuildId) return;

  const checkForUpdate = async () => {
    try {
      const response = await fetch(`/version.json?ts=${Date.now()}`, {
        cache: 'no-store',
      });
      if (!response.ok) return;

      const { buildId } = await response.json();
      if (buildId && buildId !== currentBuildId) {
        reloadForUpdate();
      }
    } catch {
      // Ignore network errors during background checks.
    }
  };

  void checkForUpdate();
  window.setInterval(checkForUpdate, 5 * 60 * 1000);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      void checkForUpdate();
    }
  });
}
